export default __webpack_public_path__ + "static/media/where-is-arn.65bdf55e.jpg";